import React from "react";
import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative overflow-hidden bg-navy" data-testid="final-cta">
      <div className="absolute inset-0 opacity-20"
           style={{ background: "radial-gradient(circle at 20% 30%, rgba(198,164,92,.6), transparent 45%), radial-gradient(circle at 85% 70%, rgba(198,164,92,.35), transparent 40%)" }} />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 py-20 md:py-28 text-center">
        <div className="gold-line mx-auto mb-7" />
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white leading-tight max-w-3xl mx-auto">
          Готови ли сте да откриете картината, която ще промени дома ви?
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-9">
          <Link to="/kartini" className="btn-gold px-8 py-3.5 rounded-sm" data-testid="cta-browse-all">
            Разгледай всички картини
          </Link>
          <Link to="/kontakti" className="border border-gold text-gold hover:bg-gold hover:text-navy transition-colors px-8 py-3.5 rounded-sm font-semibold" data-testid="cta-contact">
            Свържи се за препоръка
          </Link>
        </div>
      </div>
    </section>
  );
}
